import React from 'react'

import { Avatar, Box, Divider, Fab, IconButton, List, ListItem, ListItemAvatar, ListItemText, Typography } from '@mui/material';

import i18n from '../../../../i18n';
import { getHexColor } from '../../../hepler';
import SquareIcon from '@mui/icons-material/Square';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { deleteNoteAndExtra, getNoteAndExtraSetting, reset } from '../../../../redux/slice/Settings/NoteAndExtra/getAllNoteAndExtraSettingSlices';
import APIErorr from '../../../Components/APIErorr';
import Progress from '../../../Components/Progress';
import AlertsDialog from '../../../Components/AlertsDialog';
import InfiniteScroll from 'react-infinite-scroll-component';
import { deleteNoteAndExtraSetting } from '../../../../redux/slice/Settings/NoteAndExtra/deleteNoteAndExtraSettingSlices';
import { t } from 'i18next';
import AddEditNoteAndExtra from './AddEditNoteAndExtra';


const getAvatar = (value, isNoteAndExtra) => {


  const dir = i18n.dir()

  if (value.color === 0) {
    return <Avatar alt={value.name} src={`data:image/jpeg;base64,${value.image}`} sx={{ width: isNoteAndExtra ? 25 : 50, height: isNoteAndExtra ? 25 : 50 }} />

  }


  if (value.color !== null) {



    return <Avatar alt={value.name} sx={{ width: isNoteAndExtra ? 25 : 50, height: isNoteAndExtra ? 25 : 50, bgcolor: getHexColor(value.color), float: dir === "rtl" ? "right" : "left", marginLeft: 1, marginRight: 1 }} > </Avatar>


  }

  return <Avatar alt={value.name} sx={{ width: isNoteAndExtra ? 25 : 50, height: isNoteAndExtra ? 25 : 50, bgcolor: "rgb(231, 67, 182)", float: dir === "rtl" ? "right" : "left", marginLeft: 1, marginRight: 1 }}  > <SquareIcon /> </Avatar>


}





function NoteAndExtraMobile() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageNumber, setPageNumber] = useState(0)
  const [hasMore, setHasMore] = useState(true);
  const [searchParams] = useSearchParams();
  const [noteAndExtraList, SetNoteAndExtraList] = useState([])
  const [EditRowData, setEditRowData] = useState(null);
  const shopId = searchParams.get("ShopId")
  const noteAndExtraReduser = useSelector((state) => state.noteAndExtraSettingReduser);
  const [deleteNoteAndExtraPrgress, setDeleteNoteAndExtraPrgress] = useState(null);
  const deleteNoteAndExtraSettingReduser = useSelector((state) => state.deleteNoteAndExtraSettingReduser);
  const [dalilogAlretObject, setDalilogAlretObject] = useState({
    open: false,
    msg: "",
    title: "",
    showButtontOne: false,
    buttontOneTitle: "",
    buttonOneFun: () => { },
    showButtontTow: false,
    buttontTowTitle: "",
    buttonTowFun: () => { }
  })
  let { viewSubPage } = useParams();
  const response = noteAndExtraReduser.response;
  const sortBy = "id";
  const sortOrder = "desc"
  const pageSize = 10;

  /// handel Remove Item From Reduser Item List and Rest delete items slices to defult
  useEffect(() => {
    if (deleteNoteAndExtraSettingReduser.loading === 'succeeded') {


      const newListItems = noteAndExtraList.filter(function (obj) {
        return obj.id !== deleteNoteAndExtraPrgress;
      });



      SetNoteAndExtraList(newListItems)

      dispatch(deleteNoteAndExtra(deleteNoteAndExtraPrgress))
      setDeleteNoteAndExtraPrgress(null)
      //dispatch(RestdeleteItemSetting())

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteNoteAndExtraSettingReduser.loading])


  useEffect(() => {

    const pageNumber = 0
    dispatch(reset())
    setHasMore(true);
    setPageNumber(0);
    dispatch(getNoteAndExtraSetting({ shopId, pageNumber, pageSize, sortBy, sortOrder }))
    SetNoteAndExtraList([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopId, viewSubPage])


  useEffect(() => {

    dispatch(getNoteAndExtraSetting({ shopId, pageNumber, pageSize, sortBy, sortOrder }))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, dispatch])



  const moveNext = () => {
    if (noteAndExtraList.length < response.totalElements) {
      setPageNumber(pageNumber + 1)

    } else {
      setHasMore(false)
    }
  }


  useEffect(() => {


    if (noteAndExtraReduser.loading === 'succeeded') {

      SetNoteAndExtraList([...noteAndExtraList, ...response.content])



    }



    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [noteAndExtraReduser.loading])

  const refresh = () => {
    setHasMore(true);
    SetNoteAndExtraList([]);
    setPageNumber(0);

  }

  if (noteAndExtraReduser.loading === "pending" && noteAndExtraList.length <= 0) {
    return (<Progress/>)
  }



  if (noteAndExtraReduser.loading === "failed") {
    return (<APIErorr reduser={noteAndExtraReduser} />)
  }



  if (viewSubPage === "NoteAndExtraAddEdit" && noteAndExtraList.length > 0) {


    return <AddEditNoteAndExtra NoteAndExtra={EditRowData} />
  }









  const handEditButton = (index) => {

    setEditRowData(noteAndExtraList[index]);


    navigate({

      pathname: "/Dashboard/Settings/NoteAndExtra/NoteAndExtraAddEdit",
      search: "?" + searchParams.toString()


    })
  }

  const handeleDeleteButtonAsync = (index) => async (dispatch) => {
    const NoteAndExtraObject = noteAndExtraList[index]

    setDalilogAlretObject({ ...dalilogAlretObject, "open": false })
    setDeleteNoteAndExtraPrgress(NoteAndExtraObject.id)
    await dispatch(deleteNoteAndExtraSetting({ shopId, NoteAndExtraObject }))
  }


  const handelAddNewButton = () => {
    setEditRowData(null);


    navigate({

      pathname: "/Dashboard/Settings/NoteAndExtra/NoteAndExtraAddEdit",
      search: "?" + searchParams.toString()


    })
  }


  const handeleDeleteButton = (index) => {


    setDalilogAlretObject({
      ...dalilogAlretObject,
      "open": true,
      "title": t("Delete"),
      "msg": t("MSG7"),
      "showButtontTow": true,
      "buttontTowTitle": t("Yes"),
      "buttonTowFun": () => dispatch(handeleDeleteButtonAsync(index)),
      "showButtontOne": true,
      "buttontOneTitle": t("No"),
      "buttonOneFun": () => setDalilogAlretObject({ ...dalilogAlretObject, "open": false }),
    })




  }

  return (


    <Box >



      <List sx={{ marginTop: 2, height: "100%" }} >

        {noteAndExtraList !== undefined &&
          <InfiniteScroll
            dataLength={noteAndExtraList.length}
            next={moveNext}
            hasMore={hasMore}
            style={{ display: 'flex', flexDirection: "column" }} //To put endMessage and loader to the top.
            loader={noteAndExtraList.length > 0 && <Progress />}
            refreshFunction={refresh}
            pullDownToRefresh
            pullDownToRefreshContent={
              <h3 style={{ textAlign: "center" }}>&# 8595; Pull down to refresh</h3>
            }
            releaseToRefreshContent={
              <h3 style={{ textAlign: "center" }}>&# 8593; Release to refresh</h3>
            }
            pullDownToRefreshThreshold={50}

          >

            {noteAndExtraList.map((data, index) => (
              <Box key={index}
                sx={{ marginBottom: 2, marginTop: 1 }}>
                <ListItem
                  className="list-item"

                  secondaryAction={
                    <Box sx={{ display: 'flex', flexDirection: "row", flexFlow: "wrap" }}>
                      <IconButton onClick={() => handEditButton(index)} edge="start" aria-label="edit" sx={{ display: 'flex', flexDirection: "column" }}>
                        <Avatar sx={{ bgcolor: "success.main" }} variant="square" >
                          <EditIcon />

                        </Avatar>
                        <Typography variant='body2'>{t("Edit")}</Typography>
                      </IconButton>

                      <IconButton onClick={() => handeleDeleteButton(index)} edge="end" aria-label="delete" sx={{ display: 'flex', flexDirection: "column" }}>
                        <Avatar sx={{ bgcolor: "error.dark" }} variant="square" >

                          <DeleteIcon />

                        </Avatar>
                        <Typography variant='body2'>{t("Delete")}</Typography>

                      </IconButton>


                    </Box>



                  }


                >
                  <ListItemAvatar>
                    {getAvatar(data, false)}
                  </ListItemAvatar>
                  <ListItemText
                    primary={data.name}

                  />
                </ListItem>

                <ListItem>
                  <Box sx={{ width: "100%" }}>




                    {(deleteNoteAndExtraPrgress === data.id && deleteNoteAndExtraSettingReduser.loading === 'pending') ? <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: "end", alignContent: "end", flexFlow: "wrap" }}>

                      <Progress isScrroling={false} />

                    </Box> : ""}


                    {(deleteNoteAndExtraPrgress === data.id && deleteNoteAndExtraSettingReduser.loading === 'failed' ) && <Box sx={{ display: 'flex', flexDirection: "column", justifyContent: "end", alignContent: "end", flexFlow: "wrap" }}>

                      <APIErorr isScrroling={false} reduser={deleteNoteAndExtraSettingReduser} />
                    </Box>
                    }



                  </Box>

                </ListItem>
                <Divider />
              </Box>

            ))}

          </InfiniteScroll>}


      </List>



      <Box >


        <Fab onClick={handelAddNewButton} sx={{ position: "fixed", bottom: (theme) => theme.spacing(1), right: i18n.dir() !== 'rtl' && 20, }} color="primary" aria-label="add" size='large'>
          <AddIcon />

        </Fab>
      </Box>


      <AlertsDialog controlObject={dalilogAlretObject} setFunc={setDalilogAlretObject} />

    </Box>


  )
}

export default NoteAndExtraMobile